import {
  faCalendar,
  faCommentQuote,
  faFile,
  faImage,
  faLink,
  faListCheck,
  faMemo,
  faMicrophone,
  faText,
  faVideo,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCalendar as faCalendarOutline,
  faCommentQuote as faCommentQuoteOutline,
  faFile as faFileOutline,
  faImage as faImageOutline,
  faLink as faLinkOutline,
  faListCheck as faListCheckOutline,
  faMemo as faMemoOutline,
  faMicrophone as faMicrophoneOutline,
  faText as faTextOutline,
  faVideo as faVideoOutline,
} from '@fortawesome/pro-regular-svg-icons';
import { MemoType } from 'models/Memo';

// The icon for each kind of memo, the same on every screen: the composer's
// type picker, search results and notifications.
export const MEMO_TYPE_ICON: Record<MemoType, IconDefinition> = {
  [MemoType.Text]: faText,
  [MemoType.Quote]: faCommentQuote,
  [MemoType.Link]: faLink,
  [MemoType.TaskList]: faListCheck,
  [MemoType.Doc]: faMemo,
  [MemoType.Calendar]: faCalendar,
  [MemoType.Image]: faImage,
  [MemoType.Audio]: faMicrophone,
  [MemoType.Video]: faVideo,
  [MemoType.File]: faFile,
};

// The same icons in the lighter outline weight, for places where they sit on
// a plain surface instead of a filled circle: the composer's quick-type
// buttons and the type picker's icon wells.
export const MEMO_TYPE_OUTLINE_ICON: Record<MemoType, IconDefinition> = {
  [MemoType.Text]: faTextOutline,
  [MemoType.Quote]: faCommentQuoteOutline,
  [MemoType.Link]: faLinkOutline,
  [MemoType.TaskList]: faListCheckOutline,
  [MemoType.Doc]: faMemoOutline,
  [MemoType.Calendar]: faCalendarOutline,
  [MemoType.Image]: faImageOutline,
  [MemoType.Audio]: faMicrophoneOutline,
  [MemoType.Video]: faVideoOutline,
  [MemoType.File]: faFileOutline,
};

// The icon for a type the server sent. One this app doesn't know yet, or
// none at all, shows as text.
export const memoTypeIcon = (type?: string): IconDefinition =>
  MEMO_TYPE_ICON[type as MemoType] ?? MEMO_TYPE_ICON[MemoType.Text];
